var _circle, _rect, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 27,
    stroke: "white",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 13,
    width: 25,
    height: 26,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_603_221",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 8,
    width: 36,
    height: 36
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 8H46V44H10V8Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_603_221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.5184 11H15.4963C14.113 11 13 12.1256 13 13.4913V38.5087C13 39.8896 14.1278 41 15.4963 41H40.5036C41.8869 41 42.9999 39.8744 42.9999 38.5087V13.4913C43.0147 12.1256 41.9021 11 40.5184 11ZM21.8874 35.7475H17.4511V22.4507H21.8874V35.7475ZM19.6618 20.8448C18.2633 20.8448 17.1354 19.7193 17.1354 18.3235C17.1354 16.9281 18.2633 15.8025 19.6618 15.8025C21.0603 15.8025 22.1882 16.9281 22.1882 18.3235C22.1882 19.7193 21.0603 20.8448 19.6618 20.8448ZM38.5788 35.7475H34.1277L34.0223 27.8533C34.0223 27.8533 34.1277 25.7522 31.8268 25.7674C29.5262 25.7823 29.2106 27.8533 29.2106 27.8533V35.7475H24.7294V22.4507H29.0301V24.2816C29.0301 24.2816 29.2106 23.6812 30.2028 22.9759C31.1955 22.2706 32.8343 22.1205 33.5413 22.1505C34.248 22.1806 35.2102 22.0605 36.8193 23.1712C38.5487 24.3568 38.5937 27.4634 38.5937 27.4634L38.5788 35.7475Z",
    fill: "#282932"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedinIcon.19d3a65bf80f96f50e9720b6cad7718e.svg";
export { ForwardRef as ReactComponent };